import Component from './App';

export default {
  Component,
};
